export default {"src":"/_next/static/media/bag.d60b7965.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};